<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-20 15:48:35
 * @LastEditTime: 2019-08-26 15:13:10
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="layout">
    <Slider :sliderArr='sliderArr'/>
    <div class="content">
      <div class="menu">
        <div class="title" v-html="titleHtml"></div>
        <li v-for="(item, index) in menuArr" :key="index" @click="changePage(index)" class="myLi"><router-link :to="item" tag="li"><p style="font-size: 12px">{{item.englishTitle}}</p>{{item.title}}</router-link></li>

        <!--<li v-for="(item, index) in menuArr" :key="index" style="font-size: 14px">-->
          <!--<router-link :to="item" active-class="router-link-active"><p style="font-size: 12px">{{item.englishTitle}}</p>{{item.title}}</router-link>-->
        <!--</li>-->
      </div>
      <div class="container">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin/mixin';
import Slider from '@/components/Slider';
export default {
  name: 'layout',
  mixins: [mixin],
  components: {
    Slider
  },
  data() {
    return {
    };
  },
  watch: {
    '$route'(to, from) {
      this.pushData(this.$route.name);
      if (to.name.indexOf('_') <= -1) {
        this.$router.push(this.menuArr[0]);
      }
      this.$nextTick().then(() => {
        // 也支持promise
        // 这个函数中DOM必定渲染完成
        this.initPage();
      });
    }
  },
  created() {
    this.$nextTick().then(() => {
      // 也支持promise
      // 这个函数中DOM必定渲染完成
      this.initPage();
    });
  },
  methods: {
    changePage(i) {
      let cat = document.getElementsByClassName('myLi');
      cat = Array.prototype.slice.call(cat);
      cat.forEach((item, index) => {
        if (index === Number(i)) {
          item.classList.add('liBack');
        } else {
          item.classList.remove('liBack');
        }
      });
    },

    initPage() {
      let id = this.$route.params.id;
      let cat = document.getElementsByClassName('myLi');
      cat = Array.prototype.slice.call(cat);
      cat.forEach((item, index) => {
        if (index === Number(id)) {
          item.classList.add('liBack');
        } else {
          item.classList.remove('liBack');
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/reset.scss";
.layout {
  .liBack{
    background-color: #00388b;
    color: #F1F3F4;
  }
  .myLi{
    font-size: 14px;
    margin-top: 5px;
    cursor:pointer;
  }
  .content {
    width: 90%;
    margin: 30px 10% 10px;
    font-size: 0;
    .menu{
      display: inline-block;
      vertical-align: top;
      font-size: 16px;
      width: 15%;
      min-height: 420px;
      background-color: #dedede;
      box-shadow: 10px 10px 5px #cccccc;
      .title{
        font-size: 16px;
        ::v-deep span{
          font-size: 18px;
          color: #ff0000;
        }
      }
      li{
        border-bottom: 1px dashed #cccccc;
        padding-left: 20px;
        line-height: 30px;
      }
    }
    .container{
      display: inline-block;
      vertical-align: top;
      font-size: 16px;
      width: 75%;
      margin-left: 60px;
    }
    &::after{
      content: '';
      vertical-align: top;
    }
  }
  ::v-deep .Slider{
    .shadow{
      box-shadow: 0px 5px 10px 2px #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout.vue